import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, Icon, Typography, Divider } from 'ck-ui';
import { getBrandImageUrl, getImgixUrl } from 'ck-utils';
import { BundleLookPageContext } from '../context';
import { AddBundleToCart } from './AddBundleToCart';
import { BundleLookPrice } from './BundleLookPrice';
import styles from './BundleLookModal.module.scss';

const BundleLookModal = ({ onClose }) => {
  const { bundle, listName, addedCount, onDeleteProduct, groups, onChangeTag } = useContext(BundleLookPageContext);
  const canAddToCart = bundle && addedCount === bundle.totalCount;
  const color = canAddToCart ? 'success-dark' : 'danger';
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const renderButton = () => {
    if (bundle) {
      return canAddToCart ? (
        <AddBundleToCart isModal onComplete={onClose} />
      ) : (
        <Button onClick={onClose} size="large" fullwidth="mobile" className={styles.btnMarginTop}>
          Continue your bundle
        </Button>
      );
    }

    return (
      <Button
        loading={checkoutLoading}
        renderAs="a"
        href="/checkout"
        size="large"
        color="success-dark"
        fullwidth="mobile"
        className={styles.btnMarginTop}
        onClick={() => setCheckoutLoading(true)}
      >
        Proceed to checkout
      </Button>
    );
  };

  return (
    <div className={styles.root}>
      {bundle ? (
        <Typography variant="heading5">{canAddToCart ? 'YOUR BUNDLE IS DONE' : 'YOU ARE ALMOST DONE' }</Typography>
      ) : (
        <Typography variant="heading5">{listName}</Typography>
      )}
      {bundle && (
        <Typography color={color} className={styles.progress}>
          You have selected {addedCount} of {bundle.totalCount} items.
        </Typography>
      )}
      <Divider />
      <div className={styles.scrollable}>
        <div className={classnames('columns is-mobile', styles.grid)}>
          {groups.map((group, groupPosition) => group.products.map((product, productPosition) => (
            <div
            /* eslint-disable-next-line react/no-array-index-key */
              key={`${group.tag}_${productPosition}`}
              className={classnames('column', styles.product)}
            >
              {product.imageUrl ? (
                <>
                  <div className={styles.removeWrapper} style={{ backgroundImage: `url('${getImgixUrl(product.imageUrl)}')` }}>
                    <div
                      className={classnames('is-flex-centered', 'is-full-width', 'is-full-height', 'is-hidden', styles.remove)}
                      role="button"
                      tabIndex="0"
                      onClick={() => onDeleteProduct(groupPosition, productPosition)}
                    >
                      <Button secondary color="white">Remove</Button>
                    </div>
                    <Icon
                      name="cross"
                      size="regular"
                      className={styles.removeIcon}
                      onClick={() => onDeleteProduct(groupPosition, productPosition)}
                    />
                  </div>
                  <div className={styles.productInfo}>
                    <img
                      alt={product.vendor}
                      src={getBrandImageUrl(product.vendor, 'centre')}
                      className={styles.brand}
                    />
                    <Typography className="is-full-width" noWrap color="black-bis" align="centered" weight={700} capitalize>
                      {product.shortTitle || product.title}
                    </Typography>
                    <span>${product.price}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.addWrapper}>
                    <Icon name={group.icon} color="grey" className={styles.centered} />
                  </div>
                  <div className={classnames(styles.verticalCentre, styles.btnMarginTop)}>
                    <Button
                      prefix={<Icon size="small" name="plus" />}
                      fullwidth="mobile"
                      onClick={() => {
                        onClose();
                        if (onChangeTag) onChangeTag(group.tag);
                      }}
                    >
                      {group.name}
                    </Button>
                  </div>
                </>
              )}
            </div>
          )))}
        </div>
      </div>
      <Divider />
      <BundleLookPrice isModal />
      {renderButton()}
    </div>
  );
};

BundleLookModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

export { BundleLookModal };
